<div class="confirm-dialog">
  <div class="confirm-dialog-content">
    <div class="confirm-dialog-text" *ngIf="data.isConfirmHtml" [innerHTML]="data.confirmMsg || ''"></div>
    <div class="confirm-dialog-text" *ngIf="!data.isConfirmHtml">
      <h3 *ngIf="data.confirmTitle"
          class="confirm-dialog-title">{{ data.confirmTitle }}</h3>
      <p class="confirm-dialog-text">{{ data.confirmMsg || '' }}</p>
    </div>
  </div>

  <div class="confirm-dialog-buttons">
    <button mat-button
            (click)="close(false)">
      {{ data.cancelBtnText || 'Скасувати' }}
    </button>
    <button color="primary"
            mat-raised-button
            (click)="close(true)">
      {{ data.confirmBtnText || 'Підтвердити' }}
    </button>
  </div>
</div>
